import { render, staticRenderFns } from "./Donation.vue?vue&type=template&id=6dcf1b68&"
import script from "./Donation.vue?vue&type=script&lang=js&"
export * from "./Donation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dcf1b68')) {
      api.createRecord('6dcf1b68', component.options)
    } else {
      api.reload('6dcf1b68', component.options)
    }
    module.hot.accept("./Donation.vue?vue&type=template&id=6dcf1b68&", function () {
      api.rerender('6dcf1b68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Configuration/Donation/Donation.vue"
export default component.exports